export * as enterpriseMediaCategories from '@wix/auto_sdk_media_enterprise-media-categories/schemas';
export * as enterpriseMediaItems from '@wix/auto_sdk_media_enterprise-media-items/schemas';
export * as files from '@wix/auto_sdk_media_files/schemas';
export * as folders from '@wix/auto_sdk_media_folders/schemas';
